import React, { useEffect, useState } from "react";
import { anonymousUserContext, UserContext } from "../common/user/UserContext";
import { createGlobalEventBus } from "../eventBus";
//import authService from "../common/authorization/AuthorizeService";
/* import {
  QueryParameterNames,
  LoginActions,
  AuthorizationPaths,
} from "../common/authorization/ApiAuthorizationConstants"; */
import { signOut, getReturnUrl } from "../common/authorization/AuthorizeService";
import CustomPrompt from "./CustomPrompt";

function Wrapper({ app, router, user }) {
  const App = app;
  const Router = router;

  const [userContext, setUserContext] = useState(
    Object.assign(user, {
      // Add call to logout service(expect logout service to send redirectTo url)
      // If redirectTo is missing, fallback to env variable
      logout: () => {
        signOut(getReturnUrl());
        /* .then((user) => this.onRedirectSuccess(user))
          .catch((error) => this.onRedirectError(error)); */
      },
    })
  );

  useEffect(() => {
    createGlobalEventBus();
  }, []);

  return (
    <React.StrictMode>
      <Router
        basename={process.env.REACT_APP_BASENAME}
        getUserConfirmation={(message, callback) => CustomPrompt(message, callback)}
      >
        <UserContext.Provider value={userContext}>
          <App />
        </UserContext.Provider>
      </Router>
    </React.StrictMode>
  );
}

export default Wrapper;
